import { useState } from "react";
import { Reveal } from "../landing/Reveal";

const JOBS = [
  { co: "Google", role: "STEP Intern", tag: "₹80K/mo", logo: "G", grad: "from-[#7C3AED] to-[#A78BFA]" },
  { co: "Amazon", role: "SDE Intern", tag: "₹70K/mo", logo: "A", grad: "from-[#F97316] to-[#22C55E]" },
  { co: "Microsoft", role: "Explorer Fellow", tag: "₹85K/mo", logo: "M", grad: "from-[#06B6D4] to-[#4ADE80]" },
  { co: "Startups", role: "120+ open roles", tag: "Equity", logo: "🚀", grad: "from-[#22C55E] to-[#F97316]" },
];

export const CareerBite = () => {
  const [applied, setApplied] = useState({});
  return (
    <section id="careerbite" data-testid="careerbite-section" className="relative py-20 sm:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-[#06B6D4]">💼 CareerBite</p>
          <h2 className="mx-auto mt-3 max-w-xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
            Top hiring today. One tap to apply.
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {JOBS.map((j, i) => (
            <Reveal key={j.co} delay={0.06 * i} className="h-full">
              <div
                data-testid={`job-${j.co.toLowerCase()}`}
                className="flex h-full flex-col rounded-3xl border border-white/10 bg-white/[0.04] p-6 backdrop-blur-xl transition-all duration-300 hover:-translate-y-1.5 hover:border-[#06B6D4]/50"
              >
                <span className={`flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br font-display text-lg font-black text-white ${j.grad}`}>
                  {j.logo}
                </span>
                <p className="mt-4 font-display text-lg font-bold text-white">{j.co}</p>
                <p className="text-sm text-slate-400">{j.role}</p>
                <span className="mt-2 w-fit rounded-full bg-[#06B6D4]/10 px-2.5 py-1 font-jbmono text-[10px] font-bold text-[#06B6D4]">
                  {j.tag}
                </span>
                <div className="mt-auto flex gap-2 pt-6">
                  <button
                    data-testid={`apply-${j.co.toLowerCase()}`}
                    onClick={() => setApplied((a) => ({ ...a, [j.co]: !a[j.co] }))}
                    className={`flex-1 rounded-full py-2.5 text-xs font-bold transition-all ${
                      applied[j.co]
                        ? "bg-[#06B6D4] text-[#09090B]"
                        : "bg-gradient-to-r from-[#7C3AED] to-[#06B6D4] text-white"
                    }`}
                  >
                    {applied[j.co] ? "✓ Applied" : "1-Click Apply"}
                  </button>
                  <button
                    data-testid={`refer-${j.co.toLowerCase()}`}
                    className="rounded-full border border-white/15 px-3.5 py-2.5 text-xs font-bold text-slate-300 transition-colors hover:border-[#22C55E]/60 hover:text-[#22C55E]"
                    title="Refer a friend, earn ₹500"
                  >
                    ↗
                  </button>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <p className="mt-6 text-center font-jbmono text-[10px] uppercase tracking-widest text-slate-600">
          Refer a friend and earn ₹500 when they're hired
        </p>
      </div>
    </section>
  );
};
